export default {"src":"/pro/_next/static/media/goat.315edf64.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};